import { AppDispatch, RootState } from '..';
import { getFleetsSuccess, onAddingFleet, onDeletingFleet, onLoadingFleets, onUpdatingFleet } from '../reducers';

import { REACT_APP_MANAGE_SERVICE_ENDPOINT } from '../types';
import axios from 'axios';
import { fleetType } from '../../types';
import { headers } from '.';
import { notification } from '../../utils';

export const fetchFleets = () => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onLoadingFleets(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.get(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/fleets/company/${company?.company_id}`, headers(token));

    const { fleets, message } = data;

    try {
        
        dispatch(getFleetsSuccess(fleets));
        dispatch(onLoadingFleets(false));

    } catch (error: any) {
        console.log(message || error.message);
        dispatch(onLoadingFleets(false));

    }

};

export const addFleet = (values: fleetType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onAddingFleet(true));

    const { token } = getState().authReducer;
    const { company } = getState().companyReducer;

    const { data } = await axios.post(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/fleet/add`, { ...values, company_id: company?.company_id}, headers(token));

    const { success, message } = data;

    try {

        dispatch(onAddingFleet(false));
        notification(success ? 'success' : 'error', message);
        dispatch(fetchFleets());
        
    } catch (error) {

        const { message }: any = error;
        dispatch(onAddingFleet(false));
        notification('error', message);
        
    }
};

export const updateFleet = (values: fleetType) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onUpdatingFleet(true));

    const { token } = getState().authReducer;

    const { data } = await axios.put(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/fleet/update`, {...values}, headers(token));

    const { success, message } = data;

    try {

        notification(success ? 'success' : 'error', message);
        dispatch(fetchFleets());
        dispatch(onUpdatingFleet(false));
        
    } catch (error: any) {

        dispatch(onUpdatingFleet(false));
        notification('error', message);
        console.log('Fleet edit error: ', error.message);
        
    }
};

export const deleteFleet = (fleet_id: string) => async (dispatch: AppDispatch, getState: RootState) => {

    dispatch(onDeletingFleet(true));

    const { token } = getState().authReducer;

    const { data } = await axios.delete(`${REACT_APP_MANAGE_SERVICE_ENDPOINT}/fleet/${fleet_id}/delete`, headers(token));

    const { success, message } = data;

    try {

        dispatch(onDeletingFleet(false));
        notification(success ? 'success' : 'error', message);
        dispatch(fetchFleets());
        
    } catch (error: any) {

        dispatch(onDeletingFleet(false));
        notification('error', message);
        
    }
};